import type {Maybe, User} from '@cp/model';
import {RouterProvider} from 'react-router';
import {useBuildRoute} from './config/buildRoute';
import useGlobalSoundHijacker from './hooks/sound/useGlobalSoundHijacker';
import {useAuth} from './hooks/users/useAuth';

export default function AppRouter() {
  const user = useAuth();
  const router = useBuildRoute(user as Maybe<User> | undefined);

  // Enable global sound hijacking
  useGlobalSoundHijacker({
    clickSoundUrl: user?.clickSoundUrl,
    sliderSoundUrl: user?.slideSoundUrl,
    dropdownSoundUrl: user?.dropdownSoundUrl,
    checkboxSoundUrl: user?.checkSoundUrl,
    switchSoundUrl: user?.switchSoundUrl,
    soundVolume: user?.soundVolume,
    enabled: true,
  });

  return <RouterProvider router={router} />;
}
